<template>
  <v-app-bar
    app light
    color="white"
  >
    <v-row align="center">
      <v-toolbar-title>
        <router-link :to="{name: 'shop-list'}">
          <v-img
            src="@/assets/logo.jpg"
            contain
            width="176"
            height="36"
          />
        </router-link>
      </v-toolbar-title>

      <v-spacer />

      <v-menu
        v-if="logined"
        offset-y
      >
        <template #activator="{on}">
          <v-btn class="px-1" text v-on="on">{{userName}}さん</v-btn>
        </template>

        <v-list dense>
          <v-list-item @click="onLogout">
            <v-list-item-title>ログアウト</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <template v-else-if="breakpoint == BREAKPOINT_XS">
        <v-btn icon color="primary" @click="onNewUser">
          <v-icon>person_add</v-icon>
        </v-btn>
        <v-btn icon color="primary" @click="onLogin">
          <v-icon>lock_open</v-icon>
        </v-btn>
      </template>

      <template v-else>
        <v-btn color="primary" @click="onNewUser">会員登録はこちら</v-btn>
        <v-btn class="ml-4" outlined @click="onLogin">ログイン</v-btn>
      </template>
    </v-row>
  </v-app-bar>
</template>

<script>
import PartBase from '@/mixins/PartBase'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AppHeader',
  mixins: [
    PartBase
  ],
  computed: {
    ...mapGetters('login', [
      'logined',
      'userName'
    ])
  },
  methods: {
    ...mapActions('login', [
      'logout'
    ]),

    onLogin () {
      // 現在の URL を取得する
      const go = window.location.href

      // vue router を使用せずに URL を変更する
      window.location.href = '/bookin/75rent/user/login?go=' + encodeURIComponent(go)
    },

    onNewUser () {
      // 現在の URL を取得する
      const go = window.location.href

      // vue router を使用せずに URL を変更する
      window.location.href = '/bookin/75rent/user/new-user/agree?go=' + encodeURIComponent(go)
    },

    async onLogout () {
      await this.logout()
    }
  }
}
</script>
